<template>
  <div class="about">
    <h1 class="display-1 font-weight-bold mb-3">
      This is an about System {{ $route.params.id }}
    </h1>
  </div>
</template>

<script>
import { title } from "../components/mixins/title";
export default {
  name: "System",
  mixins: [title],
  methods: {
    getArgumentForTitle() {
      return {
        chain: [this.$t("system")]
      };
    }
  }
};
</script>

<style scoped></style>
